
import CopyButton from '@/components/buttons/CopyButton';
import Iconify from '@/components/iconify';
import { SCOPES } from '@/consts/scopos';
import { fDateTime } from '@/utils/formatTime';
import {
    Box,
    Button,
    Card,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material';
import Pagination from '@/components/pagination';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useApiKeys } from '../hooks';
import SkeletonRows from '../skeletons/SkeletonRows';
import CaktoApiDeleteApyKey from './CaktoApiDeleteApyKey';
import CaktopApiKeyButtonEdit from './CaktopApiKeyButtonEdit';


CaktoApiTableBody.propTypes = {
    searchTerm: PropTypes.string,
}

export default function CaktoApiTableBody({ searchTerm }) {
    const { results, count, isLoading, pagination, handleChangePage, decrementPage } = useApiKeys(searchTerm);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedScopes, setSelectedScopes] = useState([]);

    const hasNoApiKeys = !isLoading && results.length === 0;

    const handleOpenMenu = (event, scopes) => {
        setAnchorEl(event.currentTarget);
        setSelectedScopes(scopes);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
        setSelectedScopes([]);
    };

    return (
        <Card >
            <TableContainer  >
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Nome</TableCell>
                            <TableCell>Cliente ID</TableCell>
                            <TableCell>Cliente Segredo</TableCell>
                            <TableCell>Escopos</TableCell>
                            <TableCell>Data de Criação</TableCell>
                            <TableCell sx={{ textAlign: 'start' }} >Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isLoading ? (
                            <SkeletonRows />
                        ) : (
                            results.map((result) => {
                                const scopesToArray = result.scope.split(' ');
                                const translatedScopes = SCOPES.filter(scope => scopesToArray.includes(scope.name))
                                    .map(scope => scope.label);

                                return (
                                    <TableRow key={result.id} hover>
                                        <TableCell>
                                            <Typography variant="body2" className='truncate w-[150px]'>
                                                {result.name}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Box display='flex' alignItems='center' gap={1} >
                                                <Typography variant="body2" className='truncate w-[150px]' >
                                                    {result.client_id}
                                                </Typography>
                                                <CopyButton textToCopy={result.client_id} />
                                            </Box>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2">
                                                ********{result.secret_last_digits}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Button
                                                className='w-max'
                                                size="small"
                                                variant='contained'
                                                onClick={(e) => handleOpenMenu(e, translatedScopes)}
                                                endIcon={<Iconify icon="eva:arrow-ios-downward-fill" />}
                                            >
                                                Escopos ({translatedScopes.length})
                                            </Button>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2">
                                                {fDateTime(result.createdAt, 'dd/MM/yyyy')}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Box display='flex' justifyContent='start' marginLeft={-1} >
                                                <CaktopApiKeyButtonEdit apiKeyId={result.id} />
                                                <CaktoApiDeleteApyKey
                                                    apiKeyId={result.id}
                                                    currentPage={pagination.page}
                                                    resultsCount={results.length}
                                                    onPageDecrement={decrementPage}
                                                />
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                )
                            })
                        )}
                    </TableBody>

                </Table>

                {hasNoApiKeys && (
                    <Typography variant="body2" align="center" sx={{ p: 3 }}>
                        Nenhuma chave de API encontrada.
                    </Typography>
                )}

            </TableContainer>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
                PaperProps={{
                    sx: { minWidth: 200 }
                }}
            >
                {selectedScopes.map((scope, index) => (
                    <MenuItem key={index} sx={{ cursor: 'default', '&:hover': { backgroundColor: 'transparent' } }}>
                        <Typography variant="body2">{scope}</Typography>
                    </MenuItem>
                ))}
            </Menu>

            <Box sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
                <Pagination
                    count={Math.ceil(count / pagination.rowsPerPage)}
                    page={pagination.page}
                    onChange={handleChangePage}
                />
            </Box>
        </Card>

    )
}